import { PlainObject } from '../types/plainObject';

export function parseLocation<T = PlainObject>(source?: string): T {
  const { search } = location;

  return (source || search || '')
    .replace(/\??/gi, '')
    .split('&')
    .reduce<T>((acum, item) => {
      if (!item) {
        return acum;
      }

      const [key, value] = item.split('=');

      return {
        ...acum,
        [key]: value,
      };
    }, {} as T);
}
